import React from 'react'
import { Redirect, RouteComponentProps, useParams } from 'react-router'

import {
  GenericErrorView,
  IndexLayoutExtraProps,
  RouteParams,
  routes,
  useQueryParams,
  useUserAuthorizations,
} from '@sketch/modules-common'

import { LoadingState } from '@sketch/components'
import { useToast } from '@sketch/toasts'

import { LinkAccountConfirmationView } from '../LinkAccountConfirmationView'
import { SignInToLinkAccountView } from '../SignInToLinkAccountView'
import { useGetPublicWorkspaceWithFeatureFlagsQuery } from '@sketch/gql-types'

interface SsoLinkAccountRouteProps
  extends IndexLayoutExtraProps,
    RouteComponentProps {}

export const SsoLinkAccountView = (props: SsoLinkAccountRouteProps) => {
  const { hasPersonalAuthorization } = useUserAuthorizations()
  const { workspaceId } = useParams<RouteParams<'SSO_LINK_ACCOUNT'>>()
  const queryParams = useQueryParams<'SSO_LINK_ACCOUNT'>()

  const { showToast } = useToast()

  const { loading, error, data } = useGetPublicWorkspaceWithFeatureFlagsQuery({
    variables: { identifier: workspaceId },
  })

  if (loading) {
    return <LoadingState />
  }

  if (error) {
    if (error.message) showToast(error.message)

    return <GenericErrorView isInLayout />
  }

  if (!data?.publicWorkspace.features?.accountLinkingEnabled) {
    return (
      <Redirect
        to={routes.SSO_TOS.create({
          workspaceId,
          query: queryParams,
        })}
      />
    )
  }

  if (hasPersonalAuthorization) {
    return <LinkAccountConfirmationView {...props} />
  } else {
    return <SignInToLinkAccountView />
  }
}
